export default function WbsToggleCookieModal(type) {
    const modal = document.getElementById('WbsCookieModal');
    if (modal !== null) {


        if (type === 'show') {
            modal.classList.add('show');
            document.body.style.overflow = 'hidden';
        } else {
            modal.classList.remove('show');
            document.body.style.overflow = '';
        }
    }
};